import React, { useCallback, useEffect, useState } from 'react';
import { wordpressRoot } from '../../configFile';
import '../../index.css';
import Background from '../../shared/components/Background';
import { fetchBackgroundWithPage } from '../../utils';
import Actualites from './Actualites';
import './Home.css';

export default function Home() {

    const [page, setPage] = useState({})
    const [background, setBackground] = useState({})

    const fetchData = useCallback(async () => {
        const response = await fetch(wordpressRoot + 'wp-json/wp/v2/pages?slug=accueil')
        if (!response.ok) {
            return;
        }
        const pages = await response.json();
        setPage(pages[0])
    }, [])
    
    const fetchBackground = useCallback(async () => {
        const bg = await fetchBackgroundWithPage(page)
        setBackground(bg)
    }, [page])

    useEffect(() => {
        fetchData()
    }, [fetchData])

    useEffect(() => {
        fetchBackground()
    }, [page, fetchBackground])

    return (
        <>
            <Background size="900" url={background?.source_url} />
            <div className='home' >
                {
                    page &&
                    <div className='presentation'>
                        <div dangerouslySetInnerHTML={{ __html: page.content?.rendered }} />
                    </div>
                }
                <div className='trophy-container'>
                    <img src='wp-content/themes/theme-passion/images/passion-musique_gerard-cousseau_accordeon-bleu_profil.png' alt='Gérard'></img>
                    <div className='trophy'>
                        <div>
                            <img src='wp-content/themes/theme-passion/images/trophee-umpe-pierres.png' alt='Trophé-1'></img>
                            <img src='wp-content/themes/theme-passion/images/trophee-umpe-2007.png' alt='Trophé-2'></img>
                            <img src='wp-content/themes/theme-passion/images/trophee-umpe-2006.png' alt='Trophé-3'></img>
                            <img src='wp-content/themes/theme-passion/images/trophee-umpe-2004.png' alt='Trophé-4'></img>
                        </div>
                    </div>
                    <Actualites />
                </div>
            </div>
        </>
    )
}
